

















import { Vue, Component } from 'vue-property-decorator';
import { Tab, Tabs } from 'vant';
import * as config from './config';
import { BottomTabbar } from '@/components';
// tab页面组件
import ActivityBg from './components/rules/ActivityBg.vue';
import AwardsSetting from './components/rules/AwardsSetting.vue';
import InstitutionalFramework from './components/rules/InstitutionalFramework.vue';
import TheseConditions from './components/rules/TheseConditions.vue';
import SelectionCriteriaAndProcedures from './components/rules/SelectionCriteriaAndProcedures.vue';

Vue.use(Tab).use(Tabs);
@Component({
  components: {
    BottomTabbar,
    ActivityBg,
    AwardsSetting,
    InstitutionalFramework,
    TheseConditions,
    SelectionCriteriaAndProcedures,
  },
})
export default class Rules extends Vue {
  option = config.OPTHINES;
  tabArr = [
    {
      text: '活动意义',
      component: 'ActivityBg',
    },
    {
      text: '组织机构',
      component: 'InstitutionalFramework',
    },
    {
      text: '奖项设置',
      component: 'AwardsSetting',
    },
    {
      text: '参与条件',
      component: 'TheseConditions',
    },
    {
      text: '评选标准和流程',
      component: 'SelectionCriteriaAndProcedures',
    },
  ];
  activeComponent = 'ActivityBg';
  current = 0;
  handleClick(index: number, name: string) {
    this.current = index;
    this.activeComponent = name;
  }
}
